import { useAsyncData } from '@redneckz/uni-jsx/lib/hooks/useAsyncData';
import { fetchJSON } from '../../utils/fetchJSON.js';
const EMPTY_VALUE = [];
export function useAtms(regionCode) {
    const { data, error } = useAsyncData(`/api/v1/atms?regionCode=${regionCode}`, fetchMap);
    const isLoad = !data && !error;
    return { data: data || EMPTY_VALUE, isLoad };
}
const fetchMap = async (url) => {
    const result = await fetchJSON(url, { method: 'GET' });
    return Array.isArray(result) ? result : EMPTY_VALUE;
};
//# sourceMappingURL=useAtms.js.map